module.exports = __webpack_public_path__ + "images/paper-add.1789608252531.png";